<template>
  <div class="km__modules__logo--edit"
       :class="(currentSelOb !== null && currentSelOb !== undefined&& currentSelOb.colors !== undefined) ? 'withcolors':''">
    <button class="km__button--back" type="button" name="back" @click="$emit('back')" aria-label="back"></button>
    <button class="km__button--close" type="button" name="close" @click="$emit('close')" aria-label="close"></button>
    <div class="hider" v-if="currentSelOb!== null && currentSelOb !== undefined">

      <div class="action__preview__wrapper">
        <ul class="km__list--modules">
          <li class="km__list__element">
            <div class="logo__preview">
              <img alt="logo" width="50" :src="currentSelOb.previewPicture || currentSelOb.pathToLogo"/>
            </div>
          </li>
          <li class="km__list__element">
            <div class="logo__meta">
              <span class="logo__meta--format">{{ getImgFormat(currentSelOb.filename) }}</span>
              <span class="logo__meta--size">{{ sizeInCM.x }} x {{ sizeInCM.y }} cm</span>
              <!--              <span class="logo__meta&#45;&#45;date">Datum?</span>-->
              <!--suppress HtmlUnknownAttribute -->
              <span @click="deleteItem" class="km__button--text delete" type="button" name="delete">delete</span>
            </div>
          </li>
          <li class="km__list__element">
            <span class="logo__meta-quality">{{ $t("konf_logoqualityInsufficient") }}</span>
          </li>
          <li class="km__list__element" v-if="isTackleTwillMoeglich">
            <div class="action__tackletwill__wrapper">
              <div class="tw__input__wrapper">
                <input id="tw" type="checkbox" :checked="currentSelOb.hasTackleTwill" @change="onHasTackleTwillChange(($event.target as HTMLInputElement).checked)">
                <label
                    class="tw__input__layout"
                    :class="{ active: currentSelOb.hasTackleTwill }"
                    for="tw">
                </label>
              </div>
              <div class="tw__label">Tackle Twill</div>
              <div class="tw__info__button">
                <img src="/src/assets/info.svg" alt="info" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="action__buttons__wrapper">
        <ul class="km__list--modules">
          <li class="km__list__element">
            <span class="km__label logosize">Icon</span>
            <ModuleTextEditSmallButton iconclass="minus" @click="sendSizeChange('down')"/>
            <ModuleTextEditSmallButton iconclass="plus" @click="sendSizeChange('up')"/>
          </li>
          <li class="km__list__element">
            <span class="km__label logoclamp">Icon</span>
            <select class="km__input--standard" @change="changeClampTo($event, currentSelOb.id)">
              <option value="-1" :selected="-1 === currentClampTo">{{ $t("All_Colors") }}</option>
              <option v-for="colorCode in clampToOptions" :key="colorCode.colorCodeNr"
                      :value="colorCode.colorCodeNr" :selected="currentClampTo === colorCode.colorCodeNr">
                {{ colorCode.farbname }}
              </option>
            </select>
          </li>
          <li class="km__list__element">
            <span class="km__label logolayer">Icon</span>
            <ModuleTextEditSmallButton v-if="!availableZOrders.up" disabled="true" iconclass="up" @click="zOrderUp"/>
            <ModuleTextEditSmallButton v-else iconclass="up" @click="zOrderUp"/>
            <ModuleTextEditSmallButton v-if="!availableZOrders.down" disabled="true" iconclass="down" @click="zOrderDown"/>
            <ModuleTextEditSmallButton v-else iconclass="down" @click="zOrderDown"/>
          </li>
        </ul>
        <LogoColorPicker
            :logoColors="logoColors"
            @colorPickerClicked="color=>$emit('colorPickerClicked', color)
        "/>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {CommonSelObInteractions} from "@km/js/CommonSelObInteractions";
import ModuleTextEditSmallButton from "@km/components/text/TextEditSmallButton.vue";
import LogoColorPicker from "@km/components/logo/LogoColorPicker.vue";

import {computed, ComputedRef, onUnmounted, ref, Ref, watch} from "vue";
import {Color} from "@k/js/colorObject";
import {useStore} from "vuex";
import globalsObject from "@k/js/globalsObject";
import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {CONTROLLER_EVENTNAMES} from "@k/global/GlobalEventnames";
import {AnimationWaitingForTargetFactory, KEYFRAMETARGETS, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {getColorName} from "@km/store/ColorDataGetterFromResourceStore";
import {Logo, type SelectableObject, type TextObject} from "@k/js/selectableObjects";
import {useModuleLogoOpenStateStore} from "@km/store/frontendstate/useModuleLogoOpenState";

const props = defineProps<{
  currentSelOb: Logo | null
}>();

    const store = useStore();
    const eventListener = new EventListener();
    onUnmounted(() => EventVerteiler.unsubscribe(eventListener));
    const commonFunctions = new CommonSelObInteractions()
    const sizeInCM = ref({x: 0, y: 0});
    eventListener.addEventListener("displaySizeHintEvent", (data) => {
      sizeInCM.value.x = data.x;
      sizeInCM.value.y = data.y;
    });
    const isTackleTwillMoeglich =  computed(() =>store.getters["ModelStore/getCurrentOwayoProduct"]?.TackleTwillMoeglich);
    const onHasTackleTwillChange = (checked: boolean) => commonFunctions.toggleTackleTwill(props.currentSelOb as SelectableObject, checked);

    const changeClampTo = ($event, id) => {
      EventVerteiler.broadcast(
          CONTROLLER_EVENTNAMES.CHANGESELOBWITHHISTORY,
          {id, changedProperties: {clampToColor: parseInt($event.currentTarget.value)}}
      );
    };

    const animation = AnimationWaitingForTargetFactory.getUpDownAnimation('.km__modules__logo--edit');
    const keyframes = new KeyFrameTargetValues(0, 200, 50);
    const openStatusStore = useModuleLogoOpenStateStore();
    watch(()=>openStatusStore.getEditState, (newValue:KEYFRAMETARGETS)=>animation(keyframes.getTarget(newValue)))



      const clampToOptions =  computed(() => store.getters.getEntwurfColorObjects.filter((c: Color) => c.isVisible && parseInt(c.groupID) < 300)) as ComputedRef<Color[]>;
      const currentClampTo =  computed(() => props.currentSelOb.clampToColor);
      const getImgFormat =  name => name.substring(name.lastIndexOf(".") + 1, name.length);
      const getSizeinCM =  () => globalsObject.owayoJSViewer.getPartSelObSizeInCM(props.currentSelOb.id).apply(v => v.toFixed(1));
      const zOrderUp =  () => commonFunctions.zOrderUp();
      const zOrderDown =  () => commonFunctions.zOrderDown();
      const deleteItem =  () => commonFunctions.deleteItem(props.currentSelOb);
      const availableZOrders =  commonFunctions.availableZOrders as Ref<{ up, down }>;
      const sendSizeChange =  (upOrDown) => commonFunctions.sendSizeChange(upOrDown, props.currentSelOb);
      const logoColors = computed(()=>props.currentSelOb?.colors || []);
      //getColorName: (c: Color | null) => c === null ? "" : getColorName(store, c.palettenCluster, c.palette, c.colorValue),

</script>

<!--suppress CssUnknownProperty -->
<style lang="scss" scoped>
.km__modules__logo--edit {
  position: fixed;
  height: 200px;
  width: 100%;
  bottom: $cta-height;
  left: 0;
  z-index: 99;
  background: $color-white;
  padding: 40px 10px 20px 10px;
  transform: translate(0, 200px);

  &.withcolors {
    height: 200px;
    transform: translate(0, 200px);
  }

  .logo__preview {
    width: 65px;
    height: 65px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid $color-btn-border;
    overflow: hidden;
  }

  .logo__meta {
    width: 100px;

    span {
      display: block;
      line-height: 12px;
    }
  }
}

.km__modules__logo--edit {
  .action__buttons__wrapper {
    .km__list--modules {
      display: flex;
      flex-wrap: wrap;

      .km__list__element {
        width: 33.333333%;
        display: flex;
        flex-direction: row;
        position: relative;
      }

      .km__input--standard {
        width: 60px;
        height: 25px;
      }
    }
  }

  .action__preview__wrapper .km__list--modules {
    width: 80%;
    margin: 0 auto 0 auto;
    display: flex;
    flex-display: row;
    position: relative;
    top: -15px;

    .logo__meta {
      padding: 5px 10px;

      .logo__meta--format {
        font-size: 10px;
        text-transform: uppercase;
      }

      .logo__meta--size {
        display: block;
        font-size: 10px;
      }

      .logo__meta--date {
        display: block;
        font-size: 10px;
      }
    }

    .logo__meta-quality {
      display: none;
      font-size: 10px;
      font-weight: 600;
      position: absolute;
      background: white;
      z-index: 9;
      left: 50%;
      top: -18px;
      height: 90px;
      padding: 20px;
      width: 125px;

      &.active { display: block;}
    }
  }
}

.km__label {
  &.logosize {
    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMzMzMzMzO30NCjwvc3R5bGU+DQo8Zz4NCgk8Zz4NCgkJPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSI1My43LDE1LjcgNTMuNywyMy43IDcwLjcsMjMuNyA1MS43LDQyLjYgNTcuMyw0OC4zIDc2LjQsMjkuMyA3Ni40LDQ3LjUgODQuNCw0Ny41IDg0LjQsMTUuNyAJCSIvPg0KCTwvZz4NCgk8Zz4NCgkJPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSI0Ni4zLDg0LjMgNDYuMyw3Ni4zIDI5LjMsNzYuMyA0OC4zLDU3LjQgNDIuNyw1MS43IDIzLjYsNzAuNyAyMy42LDUyLjUgMTUuNiw1Mi41IDE1LjYsODQuMyAJCSIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K');
  }

  &.logolayer {
    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRkZGRkZGO3N0cm9rZTojMzMzMzMzO3N0cm9rZS13aWR0aDozLjk4MzU7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KPC9zdHlsZT4NCjxnPg0KCTxnPg0KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDguOSw4My4yYzAuNywwLjQsMS43LDAuNCwyLjQsMGwzMC4zLTE4LjljMi4yLTEuNCwyLjEtMy41LTAuMS00LjdMNTEuMSw0My4yYy0wLjctMC40LTEuOC0wLjQtMi41LDANCgkJCUwxOC41LDU5LjZjLTIuMywxLjItMi4zLDMuNC0wLjEsNC43TDQ4LjksODMuMnoiLz4NCgk8L2c+DQoJPGc+DQoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00OC45LDcwYzAuNywwLjQsMS43LDAuNCwyLjQsMGwzMC4zLTE4LjljMi4yLTEuNCwyLjEtMy41LTAuMS00LjdMNTEuMSwzMGMtMC43LTAuNC0xLjgtMC40LTIuNSwwTDE4LjUsNDYuNA0KCQkJYy0yLjMsMS4yLTIuMywzLjQtMC4xLDQuN0w0OC45LDcweiIvPg0KCTwvZz4NCgk8Zz4NCgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ4LjksNTYuOGMwLjcsMC40LDEuNywwLjQsMi40LDBsMzAuMy0xOC45YzIuMi0xLjQsMi4xLTMuNS0wLjEtNC43TDUxLjEsMTYuN2MtMC43LTAuNC0xLjgtMC40LTIuNSwwDQoJCQlMMTguNSwzMy4xYy0yLjMsMS4yLTIuMywzLjQtMC4xLDQuN0w0OC45LDU2Ljh6Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=');
  }

  &.logoclamp {
    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iMTA2cHgiIGhlaWdodD0iODguNjk5cHgiIHZpZXdCb3g9IjAgMCAxMDYgODguNjk5IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMDYgODguNjk5IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnIGlkPSJFYmVuZV8xIj4NCjwvZz4NCjxnIGlkPSJFYmVuZV8yIj4NCgk8Zz4NCgkJPHBhdGggZmlsbD0iIzFBMTgxQyIgZD0iTTUyLjk5NywxOC4xNzVjLTMwLjY2NSwwLTQ2Ljc0NiwyMi41ODctNDYuNzQ2LDI2LjE3NmMwLDMuNTg5LDE2LjA3NywyNi4xNzQsNDYuNzQ2LDI2LjE3NA0KCQkJYzMwLjY3MiwwLDQ2Ljc1NC0yMi41ODUsNDYuNzU0LTI2LjE3NEM5OS43NTEsNDAuNzYyLDgzLjY2OSwxOC4xNzUsNTIuOTk3LDE4LjE3NSBNNTIuOTk3LDY0LjQ4Ng0KCQkJYy0xMS40NjYsMC0yMC43NzktOS4wMTEtMjAuNzc5LTIwLjE0YzAtMTEuMTE2LDkuMzA4LTIwLjE0MSwyMC43NzktMjAuMTQxYzExLjQ3NCwwLDIwLjc4MSw5LjAyNCwyMC43ODEsMjAuMTQxDQoJCQlDNzMuNzc4LDU1LjQ3Niw2NC40NzEsNjQuNDg2LDUyLjk5Nyw2NC40ODYgTTUyLjk5Nyw0NC4zNTFjLTEuODk4LTIuMDkyLDMuMTAxLTEwLjA3NywwLTEwLjA3Nw0KCQkJYy01Ljc0LDAtMTAuMzc4LDQuNTE2LTEwLjM3OCwxMC4wNzdjMCw1LjU2MSw0LjY0NCwxMC4wNzIsMTAuMzc4LDEwLjA3MmM1LjczMSwwLDEwLjM5MS00LjUxMSwxMC4zOTEtMTAuMDcyDQoJCQlDNjMuMzg4LDQxLjc5Miw1NC42MTQsNDYuMTI0LDUyLjk5Nyw0NC4zNTEiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg==');
    background-size: 21px;
  }
}

/* ***********************************
*	TEXT EDIT - Tackletwill
* ********************************** */
.tw__input__wrapper {
  position: relative;

  #tw {
    visibility: hidden;
  }

  .tw__input__layout {
    border: 2px solid #C0BEBF;
    border-radius: 50%;
    cursor: pointer;
    left: 0;
    position: absolute;
    top: 0;
    width: 22px;
    height: 22px;

    &.active {
      background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iS29tcG9uZW50ZV80NV8xNSIgZGF0YS1uYW1lPSJLb21wb25lbnRlIDQ1IOKAkyAxNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTMuMTE3IiBoZWlnaHQ9IjEwLjMwNCIgdmlld0JveD0iMCAwIDEzLjExNyAxMC4zMDQiPg0KICA8ZyBpZD0iR3J1cHBlXzMxNCIgZGF0YS1uYW1lPSJHcnVwcGUgMzE0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDI1LjMzIC0yNDcuODQ4KSI+DQogICAgPHBhdGggaWQ9IlBmYWRfMjczIiBkYXRhLW5hbWU9IlBmYWQgMjczIiBkPSJNNDMwLjA0NywyNTguMTUybC00LjcxNy00LjcxOCwxLjktMS45LDIuODE0LDIuODE1LDYuNS02LjUsMS45LDEuOVoiIGZpbGw9IiMyNDI0MjQiLz4NCiAgPC9nPg0KPC9zdmc+DQo=);
      background-repeat: no-repeat;
      background-position: center;
      background-size: 10px auto;
    }
  }
}

.action__tackletwill__wrapper {
  position: relative;
  width: 148px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  top: 20px;
  left: -10px;
}

.tw__label {
  font-size: 15px;
  padding-top: 3px;
  margin-left: 10px;
  color: black;
  width: 80px;
}

.tw__info__button {
  width: 25px;
  margin-right: 5px;
  margin-left: 12px;

  img {
    position: relative;
    top: 2px;
  }
}

</style>
